module.exports = __webpack_public_path__ + "img/car_shina2_44.ebfef22e.jpg";